import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { RegistrationAuthoritiesService } from './registration-authorities.service';

export const registrationAuthoritiesForNonprofitAddResolver: ResolveFn<void> = async () => {
  try {
    await inject(RegistrationAuthoritiesService).getRegistrationAuthoritiesForNonprofitAdd();
  } catch {
    // A failed lookup must not cancel navigation into Nonprofit Management; the
    // add-organization registration authority list will populate on a later retry.
  }
}
